import React, { useEffect, useState } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { Assignment } from '@material-ui/icons';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Paper } from '@material-ui/core';
import { wsFindBy, wsGet } from 'services/WService';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { currency } from 'hooks/Pipe';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  detail: {
    display: 'flex',
    alignItems: 'center',
    '& span': {
      marginLeft: '10px',
      marginRight: '10px',
      color: '#000000bf',
      fontWeight: 'bold',
      fontSize: '15px'
    }
  },
  paper: {
    padding: '0px 11px 4px 10px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Nombre producto', accessor: 'product' },
  { Header: 'Cant. Unid.', accessor: 'commited_units' },
  { Header: 'Paquete', accessor: 'package' },
  { Header: 'Unidad', accessor: 'unit' },
  { Header: 'Unid. paq.', accessor: 'unitPackage' },
  { Header: 'Precio unit.', accessor: 'unitPrice' },
  { Header: 'Precio Paq.', accessor: 'packagePrice' },
  { Header: 'Monto', accessor: 'amount' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function OderDetailModal(props) {
  const classes = useStyles();

  const { title, openDetailId, open, setOpen } = props;

  const [order, setOrder] = useState({});
  const [orderDetails, setOrderDetails] = useState([]);

  async function getOrder() {
    let response = await wsGet('ordm/order', openDetailId);
    if (response.success) setOrder(response.data);
  }

  async function getOrderDetails() {
    let response = await wsFindBy('ordm/order-detail', 'ordm_order_id', openDetailId);
    if (response.success) setOrderDetails(response.data);
  }

  useEffect(() => {
    if (openDetailId && open) {
      getOrderDetails();
      getOrder();
    }
  }, [openDetailId]);

  return (
    <ModalFull title={title + ' -  ' + order.CardName} open={open} setOpen={setOpen}>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color={props.themeContext.buttonColor}>
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Detalle Listado de Pedidos</h4>
            </CardHeader>
            <CardBody>
              <GridContainer style={{ marginBottom: '15px' }}>
                <GridItem xs={12} lg={3} className={classes.detail}>
                  <Paper className={classes.paper}>
                    <h5>Vendedor: </h5>
                    <span>{order.SlpName}</span>
                  </Paper>
                </GridItem>
                <GridItem xs={12} lg={3} className={classes.detail}>
                  <Paper className={classes.paper}>
                    <h5>Total: </h5>
                    <span>S/ {parseFloat(order.total_amount).toFixed(2)}</span>
                  </Paper>
                </GridItem>
                <GridItem xs={12} lg={3} className={classes.detail}>
                  <Paper className={classes.paper}>
                    <h5>Estado: </h5>
                    <span>
                      {order.state == 'X'
                        ? 'Pendiente'
                        : order.state == 'S'
                        ? 'Sin Stock'
                        : order.state == 'A'
                        ? 'Anulado'
                        : order.state == 'E'
                        ? 'Editado'
                        : order.state == 'P'
                        ? 'Procesado'
                        : 'Retenido'}
                    </span>
                  </Paper>
                </GridItem>
                <GridItem xs={12} lg={3} className={classes.detail}>
                  <Paper className={classes.paper}>
                    <h5>Pedido: </h5>
                    <span>{moment(order.start_date).format('MM/DD/YYYY')}</span>
                  </Paper>
                </GridItem>
              </GridContainer>

              <ReactTable
                excelName={'Detalles-de-pedidos-socio-' + order?.CardCode}
                defaultWidth={1200}
                indexRow={[0, 2, 3, 4, 5, 6, 7, 8, 9]}
                widthRow={[80, 120, 100, 100, 100, 120, 120, 120, 10]}
                columns={columns}
                data={orderDetails.map((orderDetail, i) => {
                  return {
                    num: i + 1,
                    product: orderDetail.ItemName,
                    commited_units: orderDetail.commited_units,
                    package: orderDetail.packages,
                    unit: orderDetail.units,
                    unitPackage: orderDetail.units_package,
                    unitPrice: currency(orderDetail.units_price),
                    packagePrice: currency(orderDetail.package_price),
                    amount: currency(orderDetail.amount),
                    actions: ''
                  };
                })}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </ModalFull>
  );
});
